import { render, staticRenderFns } from "./KarmaProgramAdd.vue?vue&type=template&id=3aa9017e&"
import script from "./KarmaProgramAdd.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramAdd.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports